import Vue from 'vue';
import ContactUsForm from '../../qaamgo/modules/sat/components/ContactUsForm.vue';
import '../../../scss/critical.scss';
import '../../../scss/contact_us.scss';
import ContactUsFormModal from '../../lib-sat/contact-us/ContactUsFormModal.vue';
import { contactUsModalRouter } from '../../lib-sat/user/modal/contact_us/router';
import Router from 'vue-router';
import { getPiniaInstance } from '../../lib-sat/store/page-store';

Vue.use(Router);

import(
    /* webpackMode: "eager" */
    '../qg-main'
).then(function () {
    import(
        /* webpackMode: "eager" */
        '../../qaamgo/modules/sat/user.js'
    ).then(() => {
        import(
            /* webpackMode: "lazy-once" */
            `../translations/sat-translations.js`
        ).then(function () {
            if (window.sat.enableContactUsOsTicket) {
                if (document.getElementById('contactUsModal') === null) {
                    const contactUsModalEl = document.createElement('div');
                    contactUsModalEl.setAttribute('id', 'contactUsModal');

                    document.body.appendChild(contactUsModalEl);
                }

                new Vue({
                    el: '#contactUsModal',
                    name: 'ContactUsFormModalRoot',
                    components: { ContactUsFormModal },
                    router: contactUsModalRouter,
                    pinia: getPiniaInstance(),
                    render(h) {
                        return h(ContactUsFormModal);
                    },
                });
            }

            //render the contact us modal in the user area onto a different element,
            //because the otherwise the modal would not render with the form
            if (document.getElementById('dashboardContactUsForm') !== null) {
                new Vue({
                    el: '#dashboardContactUsForm',
                    name: 'DashboardContactUsFormRoot',
                    components: { ContactUsForm },
                    pinia: getPiniaInstance(),
                    render(h) {
                        return h(ContactUsForm);
                    },
                });
            }
        });
    });
});
